const module = angular.module('webremote.directive.objectmanager.views', [])

require('./collapse/controller')
require('./default/controller')
require('./nested/controller')
require('./manager/controller')
